// BEKEF Cuisine — impression étiquettes QL-820NWB
// Tablette Android : Brother Print Service Plugin + Bluetooth

const DISHES = JSON.parse(document.getElementById("dishes-data").textContent);

const CAT_LABELS = {
  couscous: "Couscous",
  tunisien: "Plat tunisien",
  poulet:   "Poulet",
  autre:    "Autre",
};

const MAX_QTY = 50;

// --- State ---
let currentDish = null;
let currentQty = 1;

// --- DOM ---
const grid       = document.getElementById("grid");
const overlay    = document.getElementById("overlay");
const modalName  = document.getElementById("modalName");
const modalCat   = document.getElementById("modalCat");
const qtyEl      = document.getElementById("qty");
const minusBtn   = document.getElementById("minus");
const plusBtn    = document.getElementById("plus");
const closeBtn   = document.getElementById("close");
const cancelBtn  = document.getElementById("cancel");
const printBtn   = document.getElementById("print");
const toast      = document.getElementById("toast");
const printArea  = document.getElementById("printArea");

// --- Render grid ---
function renderGrid() {
  grid.innerHTML = "";
  DISHES.forEach(dish => {
    const tile = document.createElement("button");
    tile.className = "tile";
    tile.dataset.cat = dish.cat;
    tile.innerHTML = `<div class="tile-name">${dish.name}</div>`;
    tile.addEventListener("click", () => {
      if (tile.classList.contains("missing")) {
        showToast(`Étiquette "${dish.name}" non exportée`, "warn");
        return;
      }
      openModal(dish);
    });

    // Pre-check if image exists, mark missing ones
    const img = new Image();
    img.onerror = () => tile.classList.add("missing");
    img.src = dish.file;

    grid.appendChild(tile);
  });
}

// --- Modal ---
function openModal(dish) {
  currentDish = dish;
  currentQty = 1;
  modalName.textContent = dish.name;
  modalCat.textContent = CAT_LABELS[dish.cat];
  updateQty();
  overlay.hidden = false;
}

function closeModal() {
  overlay.hidden = true;
  currentDish = null;
}

function updateQty() {
  qtyEl.textContent = currentQty;
  minusBtn.disabled = currentQty <= 1;
  plusBtn.disabled  = currentQty >= MAX_QTY;
  minusBtn.style.opacity = currentQty <= 1 ? 0.35 : 1;
  plusBtn.style.opacity  = currentQty >= MAX_QTY ? 0.35 : 1;
}

minusBtn.addEventListener("click", () => { if (currentQty > 1) { currentQty--; updateQty(); } });
plusBtn .addEventListener("click", () => { if (currentQty < MAX_QTY) { currentQty++; updateQty(); } });
closeBtn.addEventListener("click", closeModal);
cancelBtn.addEventListener("click", closeModal);
overlay.addEventListener("click", (e) => { if (e.target === overlay) closeModal(); });

// --- Print ---
printBtn.addEventListener("click", async () => {
  if (!currentDish) return;
  const dish = currentDish;
  const qty  = currentQty;

  printBtn.disabled = true;
  printBtn.textContent = "Préparation…";

  await renderPrintArea(dish, qty);

  printBtn.textContent = "IMPRIMER";
  printBtn.disabled = false;

  // Fire browser print dialog → Brother Print Service Plugin → Bluetooth QL-820NWB
  window.print();

  closeModal();
  showToast(`${qty} étiquette${qty > 1 ? "s" : ""} · ${dish.name}`, "ok");
});

// --- Dates dynamiques (fabrication + DLC J+4) ---
const DLC_DAYS = 4;
function formatDate(d) {
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  return `${dd}.${mm}.${yy}`;
}

function renderPrintArea(dish, qty) {
  printArea.innerHTML = "";
  const today = new Date();
  const dlc = new Date(today);
  dlc.setDate(today.getDate() + DLC_DAYS);
  const fabText = formatDate(today);
  const dlcText = formatDate(dlc);

  const promises = [];
  for (let i = 0; i < qty; i++) {
    const page = document.createElement("div");
    page.className = "print-label";
    page.innerHTML = `
      <div class="label-content">
        <img src="${dish.file}">
        <div class="date-mask date-fab">${fabText}</div>
        <div class="date-mask date-dlc">${dlcText}</div>
      </div>
    `;
    printArea.appendChild(page);
    const img = page.querySelector("img");
    promises.push(new Promise(res => {
      if (img.complete) res();
      else { img.onload = res; img.onerror = res; }
    }));
  }
  return Promise.all(promises);
}

// --- Toast ---
let toastTimer = null;
function showToast(msg, kind = "ok") {
  const prefix = kind === "warn" ? "⚠  " : "✓  ";
  toast.textContent = prefix + msg;
  toast.classList.toggle("toast-warn", kind === "warn");
  toast.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { toast.hidden = true; }, 2400);
}

// --- Prevent accidental browser gestures ---
document.addEventListener("gesturestart", e => e.preventDefault());
document.addEventListener("contextmenu", e => e.preventDefault());

// --- Init ---
renderGrid();
